import * as Types from "../constants/actionTypes";

const initialState = {
  loading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case Types.IS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case Types.IS_LOADED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};
